var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountInvoices"}},[(_vm.loading)?_c('LoadingLayout',{attrs:{"page":true}}):_c('Page',{attrs:{"title":_vm.$t('Invoices')}},[[_c('Layout',[_c('LayoutSection',[_c('Card',[_c('DataTable',{attrs:{"columns":[
                {
                  key: 'invoiceNumber',
                  label: _vm.$t('AccountInvoices.Invoice #')
                },
                {
                  key: 'forDate',
                  label: _vm.$t('For Month'),
                  format: 'dateMonthYearLong',
                  sortable: true
                },
                {
                  key: 'amount',
                  label: _vm.$t('Total'),
                  format: 'currency',
                  sortable: true,
                  formatContext: _vm.context
                }
              ],"row-actions":function (n) { return _vm.getRowActions(n); },"sort":_vm.sortBy,"rows":_vm.formattedInvoices,"pagination":{
                offset: _vm.offset,
                limit: _vm.limit,
                total: _vm.formattedInvoices.length,
                updateOffset: function (val) { return _vm.offset = val; },
                updateLimit: _vm.updateLimit
              },"loading":_vm.loading,"compact":""},on:{"update:sort":function($event){_vm.sortBy=$event}}})],1)],1)],1)]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }